import React from 'react';
import {
  APP_MODAL_ROUTES,
  CREDIT_REQUEST_ROUTES,
  SHORT_PAY_CREDIT_REQUEST_ROUTES,
} from '@/navigators/routes';
import {
  AppModalStackParams,
  ShortPayCreditRequestStackParams,
} from '@/navigators/types';
import { CompositeNavigationProp, RouteProp } from '@react-navigation/native';
import { CreditRequestInvoiceItemsContent } from '@/components/credit-request/credit-request-invoice-items-content';
import { PageContainer } from '@/components/page-container';
import { StackNavigationProp } from '@react-navigation/stack';
import { useAuthenticatedUserContext } from '@/contexts/user-context';
import { useCreditRequestInvoiceItems } from '@/hooks/credit-requests/use-credit-request-invoice-items';
import { useCreditRequestInvoiceStore } from '@/stores/credit-request-invoice-store';

interface Props {
  navigation: CompositeNavigationProp<
    StackNavigationProp<
      ShortPayCreditRequestStackParams,
      SHORT_PAY_CREDIT_REQUEST_ROUTES.Items
    >,
    StackNavigationProp<AppModalStackParams, APP_MODAL_ROUTES.CreditRequest>
  >;
  route: RouteProp<
    ShortPayCreditRequestStackParams,
    SHORT_PAY_CREDIT_REQUEST_ROUTES.Items
  >;
}

export const ShortPayCreditRequestItemsScreen: React.FC<Props> = ({
  navigation,
  route,
}) => {
  const { onComplete, orderInvoiceUUID, subtotalInMicros, title } =
    route.params;
  const {
    selectedRestaurantRelationship: { supplierUUID },
    selectedRestaurantUUID,
  } = useAuthenticatedUserContext();
  const { items } = useCreditRequestInvoiceItems({
    orderInvoiceUUID,
    restaurantUUID: selectedRestaurantUUID,
    supplierUUID,
  });
  const addBatchItem = useCreditRequestInvoiceStore((s) => s.addBatchItem);

  return (
    <PageContainer
      navigationHeaderProps={{
        centerTitle: true,
        onBackPress: navigation.goBack,
        responsive: true,
        showBackButton: true,
        showShadow: false,
        title,
      }}
    >
      <CreditRequestInvoiceItemsContent
        items={items}
        onNext={() => {
          navigation.navigate(SHORT_PAY_CREDIT_REQUEST_ROUTES.Details, {
            onComplete,
            orderInvoiceUUID,
            subtotalInMicros,
            title,
          });
        }}
        onSelectItem={(variantPack, searchResultItem, existingBatchLineItem) =>
          navigation.navigate(APP_MODAL_ROUTES.CreditRequest, {
            params: {
              confirmOnExit: true,
              eligibleForCredit: searchResultItem.eligible_for_credit,
              existingBatchLineItem,
              guaranteed: searchResultItem.guaranteed,
              itemDetail: variantPack,
              multiRequest: true,
              onSuccess: addBatchItem,
              orderInvoiceUUID,
            },
            screen: CREDIT_REQUEST_ROUTES.Base,
          })
        }
      />
    </PageContainer>
  );
};
